import { render } from "./Relogin.vue?vue&type=template&id=39f11242&scoped=true"
import script from "./Relogin.vue?vue&type=script&lang=ts"
export * from "./Relogin.vue?vue&type=script&lang=ts"

import "./Relogin.vue?vue&type=style&index=0&id=39f11242&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-39f11242"

export default script